import { Header } from "@/src/components/Header";

import { getHeaderComponent } from "@/src/api/services/component";
import { HeaderActionProps } from "@/src/components/Header/lib/type";
import { useQuery } from "@tanstack/react-query";

export const HeaderFetchWrapper = ({
  actions,
}: {
  actions?: Array<HeaderActionProps>;
}) => {
  const { data: headerData } = useQuery<any>({
    queryKey: ["modalHeader"],
    queryFn: getHeaderComponent,
    staleTime: 900000,
  });

  return !headerData?.hidden ? (
    <Header
      {...headerData?.props}
      actions={actions || headerData?.props?.actions}
    />
  ) : null;
};

export const ModalHeader = ({ onCancel }: { onCancel: () => void }) => {

  return (
    <div className="relative">
      <HeaderFetchWrapper />
    </div>
  );
};
